/*@flow*/
export default {
  tenantStatus: ['Current Lessee', 'Past Tenant', 'Owner-Occupant', 'Unknown'],
  propertyStatus: ['--'],
  eventStatus: ['Scheduled', 'Cancelled'],
  developmentStatus: [
    'Completed',
    'Proposed',
    'Under Construction',
    'Demolished',
  ],
  listingStatus: ['Active', 'Past'],
  unitStatus: ['Vacant', 'Occupied'],
  buildingStatus: ['Existing', 'Proposed', 'Under Construction', 'Demolished'],
  streetscapeAssetStatus: [
    'Operational',
    'Needs Attention',
    'Removed',
    'Decommissioned',
  ],
  streetscapeIssueStatus: ['Open', 'Closed'],
  contactStatus: ['Current', 'Past'],
  contactTypes: [
    'Realtor',
    'Architect',
    'Developer',
    'Property Owner',
    'Business Owner',
    'Super',
    'Manager',
    'Residential Contact',
    'Other',
  ],
  tenantCategories: [
    'Arts & Culture',
    'Businesses & Attractions',
    'Food & Drink',
    'Education',
    'Hotels & Event Venues',
    'Industrial',
    'Neighborhood Amenities',
    'Services',
    'Shopping',
  ],
  propertyType: [
    'Affordable Housing',
    'Healthcare',
    'Hospitality',
    'Industrial',
    'Investment',
    'Land',
    'Multifamily',
    'Office',
    'Residential',
    'Retail',
    'Other',
  ],
  use: [
    'Office',
    'Residential',
    'Industrial',
    'Hotel',
    'Retail',
    'Community Facility',
    'Commercial',
    'Institutional',
    'Soft Site',
    'Other',
  ],
  listingType: [
    'For Lease',
    'For Sale',
    'For Lease & For Sale'
  ],
  leaseType: [
    'Triple Net',
    'Double Net',
    'Gross Lease',
    'Ground Lease',
    'Single Net Lease',
    'Other',
  ],
  developmentType: [
    'New Construction',
    'Major Renovation',
    'Minor Alteration',
    'Other',
  ],
  ownershipType: ['Condo', 'Rental', 'Hotel', 'Coop', 'Other'],
  ownership: [
    'Private',
    'Public',
    'Public/Private',
    'Fee Simple',
    'Ground Lease',
    'Leasehold Interest',
    'Other',
  ],
  visibility: ['Public', 'Private'],
  vacancyStatus: ['Vacant', 'Occupied'],
};
